import Typography from "@material-ui/core/Typography";
import React, {Fragment} from "react";
import {makeStyles} from "@material-ui/core/styles";
import dateFormat from "dateformat";
import {getMessage} from "../../util";
import Chip from "@material-ui/core/Chip";
import {Card, CardContent} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
        chip: {
            marginLeft: theme.spacing(2)
        },
        paragraph: {
            margin: theme.spacing(2)
        },
        number: {
            fontFamily: "Montserrat",
            fontSize: "2.5rem",
            fontWeight: "bold"
        }
    }
));


const QueueInfo = (props) => {
    const classes = useStyles();

    return (
        <div className={classes.paragraph}>
            <Typography variant="h5" >
                En cola: {props.total}
            </Typography>
        </div>
       )
}

export default QueueInfo;